import React, { useState, useEffect, useCallback } from 'react';
import { Container, Alert, Button, Row, Col } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import { settings } from '../../../config/settings';


export default function SurveyPlayer({ episode }) {

    const [data, setData] = useState(null);
    const [errors, setErrors] = useState('');


    useEffect(() => {
        init()
    }, [episode]);


    async function init() {
        if (episode && episode.idFile) {
            var response = await DataManager.getItem('episode_file', episode.idFile)
            console.warn('episode_file', response)
            if (response.success === 1) {
                let b = response.body[0]
                console.log(b)
                setData(b)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
            }
        }
    }


    if (data !== null) {
        
        var file_url = settings.ckdPath + "/upload/episode_file/" + data.file.hash + "." + data.file.extension
        console.warn(file_url)

        return (
            <>
                {errors.length > 0 &&
                    <Alert variant='danger mt-5'>
                        {errors}
                    </Alert>
                }


                <Container fluid='md' className='text-center'>
                    {data.file && data.file.extension === 'pdf' ? (
                        <iframe src={file_url} width="100%" height="600px" crossorigin="anonymous" />
                    ) : (
                        <></>
                    )}
                </Container>
            </>
        );
    }
};